export const update = (payload) => ({
    type: 'UPDATE_SETTING',
    payload,
});